/**
 * Member Filter to filter out the list of members
 * based on the select checkbox.
 *
 * This requires the the checkbox inputs be wrapped with a container
 * that has a memberFilter class.
 *
 * Each member container should have the class member
 */
function MemberFilter() {this.init(); }

MemberFilter.prototype.init = function () {
    "use strict";

    // private constructor 
    var __construct = function () {
        
        jQuery('#memberTabs').on('toggled', function (event, tab) {
            resetForms();
        });

        // Respond to when a checkbox is checked/unchecked
        jQuery(".memberFilter input:checkbox").click(function () {
            var classToShow = jQuery(this).val(),
                classString = "";

            // Loop through each of the checked inputs and create a list
            // of their values that we can use to show them later.
            
            // Check that something has been checked, if not we want
            // all of the inputs to display
            if(jQuery('.memberFilter input:checkbox:checked').length > 0){
                
                // Hide all the inputs initially so we can choose which
                // ones show
                jQuery(".member").hide();
                jQuery('.memberFilter input:checkbox:checked').each(function () {
                    var sThisVal = jQuery(this).val();
                    jQuery("."+sThisVal).show();
                });
                
            }else{
                jQuery(".member").show();
            }
        });

        // Filter Select boxes
        jQuery(".select-filter").change(function () {
            var selectedVal = jQuery(this).val();
            
            if (selectedVal !== "") {
                jQuery(".member").hide();
                jQuery("." + selectedVal).show();
            } else {
                jQuery(".member").show();
            }
        });
        
        /**
         * Reset the checkboxex, state select and display all members
         */
        function resetForms() {
            jQuery(".member").show();
            
            jQuery('.memberFilter input:checkbox:checked').each(function () {
                jQuery(this).attr('checked', false);
            });
            
            jQuery(".state-filter").val("");
        }

    }();
};